import { KycForm } from "@/components/KycForm";
import { ClientShell, useClientUser } from "@/pages/client/ClientShell";

export default function ClientKyc() {
  const user = useClientUser();
  if (!user) return null;
  return (
    <ClientShell user={user} title="KYC Verification">
      <p className="mt-2 text-sm text-slate-500">PAN card, Aadhaar (or another government ID) and your 16-digit demat account number. Reviewed by the desk before your first off-market transfer.</p>
      <KycForm />
    </ClientShell>
  );
}
